export default (number) => {
    return number ? number.toLocaleString() : 0
}



// WEBPACK FOOTER //
// ./src/helpers/common/formatThousandNumber.js